
import { CorrespondenceEmailModel } from './../models/message-centre.models';

export class RecipienthHelper {
    static checkRecipientType(email: CorrespondenceEmailModel) {
        switch(email.recipientTypeName) {
            case "Technical Manager":
                email.isTechnicalManagerEmail = true;
                break;
            case "Inspecting Company":
                email.isInspectingCompanyEmail = true;
                break;
            case "Company Email":
                email.isInspectingCompanyEmail = true;
                break;
            case "Inspection Company":
                email.isInspectingCompanyEmail = true;
                break;
            case "Ship Manager":
                email.isShipManagerEmail = true;
                break;                                   
            case "Master":
                email.isMasterEmail = true;
                break;
            case "Agent":
                email.isAgentEmail = true;
                break;
            case "Correspondence":
                email.isCorrespondenceEmail = true;
                break;
            case "Inspector":
                email.isInspectorEmail = true;
                break;
            case "Trainee":
                email.isTraineeEmail = true;
                break;
        }
        return email;
    }
    
}